module.exports = __webpack_public_path__ + "static/img/pay_fail_vava.e1745f89.webp";